import * as $ from 'jquery';
import {additionalInformationElementStorage} from '../Storage/NavAdditionalInformationStorage';

export function addNavAdditionalInformationListener(): void {
  const navAsideSelector: string = '.js-navAside';
  const $navAside = $(navAsideSelector);
  const $additionalInformationLink = $('.js-additionalInformationLink');
  const hideClass: string = 'hide';

  initializeNavigationPoints(navAsideSelector);

  $additionalInformationLink.on('mouseover', function (): void {
    let $additionalInformationElement: any;
    const elementUid: number = parseInt($(this).data('additionalInformation'), 10);
    if (elementUid in additionalInformationElementStorage) {
      $navAside.find('.js-' + elementUid).removeClass(hideClass);
    } else {
      $additionalInformationElement = $(this).parent().find(`.js-navAdditionalInformation[data-additional-information="${elementUid}"]`);
      if ($additionalInformationElement) {
        const $additionalInformationElementImage = $additionalInformationElement.find('.js-nav__additionalInformationImage');
        if ($additionalInformationElementImage) {
          $additionalInformationElementImage.attr('src', $additionalInformationElementImage.data('src'));
        }
        additionalInformationElementStorage[elementUid] = true;
      }
    }

    if ($additionalInformationElement) {
      $additionalInformationElement.clone().appendTo($navAside).removeClass(hideClass).addClass('active js-' + elementUid);
    }
  });

  $additionalInformationLink.on('mouseleave', function (): void {
    $navAside.find('.js-navAdditionalInformation.active').addClass(hideClass);
  });
}

function initializeNavigationPoints(navAsideSelector: string): void {
  const activeClass: string = 'nav__aside--active';
  const $navListItems = $('.js-navListItem');

  $navListItems.each(function () {
    const $this = $(this);
    if ($this.find('.js-navAdditionalInformation').length) {
      $this.find(navAsideSelector).addClass(activeClass);
    }
  });
}
